"use strict";

var _typeof = require("/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Context = void 0;
var _dateFns = require("date-fns");
var _nodes = require("./nodes");
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var unevaluated = function unevaluated(func) {
  // eslint-disable-next-line no-param-reassign
  func.lazy = true;
  return func;
};
function isNotArray(arg) {
  return !Array.isArray(arg);
}
var flatten = function flatten() {
  var ret = [];
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  args.forEach(function (arg) {
    if (isNotArray(arg)) {
      ret.push(arg);
    } else {
      arg.forEach(function (item) {
        flatten(item).forEach(function (flat) {
          ret.push(flat);
        });
      });
    }
  });
  return ret;
};
var gcd = function gcd(a, b) {
  if (!b) {
    return a;
  }
  return gcd(b, a % b);
};
var Context = /*#__PURE__*/function () {
  function Context() {
    var _this = this;
    var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Context);
    this.IF = unevaluated(function (fn, condition, ifyes, ifno) {
      if (fn(condition)) {
        return fn(ifyes);
      }
      return fn(ifno);
    });
    this.CASE = unevaluated(function (fn, rootCase) {
      if (rootCase === undefined) {
        return null;
      }
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }
      for (var i = 0, j = 0, len = args.length; j < len; _ref = [i += 2, j += 2], i = _ref[0], j = _ref[1], _ref) {
        var _ref;
        var comparable = args[i];
        if (i + 1 < args.length && fn(new _nodes.BinOp(comparable, _nodes.Op.Eq, rootCase))) {
          return fn(args[i + 1]);
        }
      }
      if (args.length > 0 && args.length % 2 === 1) {
        return fn(args[args.length - 1]);
      }
      return null;
    });
    this.COALESCE = unevaluated(function (fn) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }
      [].slice.call(args);
      args.slice(1);
      for (var i = 0; i < args.length; i += 1) {
        var arg = args[i];
        var result = fn(arg);
        if (result !== null) {
          return result;
        }
      }
      return null;
    });
    this.DATE = function (arg) {
      return (0, _dateFns.parseISO)(_this.dateTimeParam(arg));
    };
    this.DATETIME = function (arg) {
      return (0, _dateFns.parseISO)(_this.dateTimeParam(arg));
    };
    this.TIME = function (arg) {
      return (0, _dateFns.parse)(_this.dateTimeParam(arg), 'kk:mm:ss', new Date());
    };
    Object.entries(ctx).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      _this[key] = value;
    });
  }

  // eslint-disable-next-line class-methods-use-this
  _createClass(Context, [{
    key: "LEN",
    value: function LEN(arg) {
      return arg.length;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "MIN",
    value: function MIN() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      if (args.length === 0) {
        return null;
      }
      var fargs = flatten(args).filter(function (arg) {
        return arg !== null;
      });
      var _fargs = _slicedToArray(fargs, 1),
        marg = _fargs[0];
      fargs.slice(1).forEach(function (arg) {
        if (arg < marg) {
          marg = arg;
        }
      });
      return marg;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "MAX",
    value: function MAX() {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      if (args.length === 0) {
        return null;
      }
      var fargs = flatten(args).filter(function (arg) {
        return arg !== null;
      });
      var _fargs2 = _slicedToArray(fargs, 1),
        marg = _fargs2[0];
      fargs.splice(1).forEach(function (arg) {
        if (arg > marg) {
          marg = arg;
        }
      });
      return marg;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "SUM",
    value: function SUM() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }
      var fargs = flatten(args).filter(function (arg) {
        return arg !== null;
      }).map(function (x) {
        return parseFloat(x);
      });
      return fargs.reduce(function (a, b) {
        return a + b;
      }, 0);
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "AVG",
    value: function AVG() {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }
      if (args.length === 0) {
        return null;
      }
      var fargs = flatten(args).filter(function (arg) {
        return arg !== null;
      }).map(function (x) {
        return parseFloat(x);
      });
      var tot = fargs.reduce(function (a, b) {
        return a + b;
      }, 0);
      return tot / args.length;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "STDEV",
    value: function STDEV() {
      for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }
      if (args.length <= 1) {
        return null;
      }
      var fargs = flatten(args).filter(function (arg) {
        return arg !== null;
      }).map(function (x) {
        return parseFloat(x);
      });
      var tot = fargs.reduce(function (a, b) {
        return a + b;
      }, 0);
      var avg = tot / fargs.length;
      var _var = fargs.map(function (x) {
        return Math.pow(x - avg, 2);
      });
      var svar = _var.reduce(function (a, b) {
        return a + b;
      }, 0);
      return Math.sqrt(svar * 1.0 / (_var.length - 1));
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "STDEVP",
    value: function STDEVP() {
      for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        args[_key9] = arguments[_key9];
      }
      if (args.length <= 1) {
        return null;
      }
      var fargs = flatten(args).filter(function (arg) {
        return arg !== null;
      }).map(function (x) {
        return parseFloat(x);
      });
      var tot = fargs.reduce(function (a, b) {
        return a + b;
      }, 0);
      var avg = tot / fargs.length;
      var _var = fargs.map(function (x) {
        return Math.pow(x - avg, 2);
      });
      var svar = _var.reduce(function (a, b) {
        return a + b;
      }, 0);
      return Math.sqrt(svar * 1.0 / _var.length);
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "CONCAT",
    value:
    // eslint-disable-next-line class-methods-use-this
    function CONCAT(base) {
      var sbase = base.toString();
      for (var _len10 = arguments.length, args = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
        args[_key10 - 1] = arguments[_key10];
      }
      [].slice.call(args);
      args.slice(1);
      args.filter(function (arg) {
        return arg !== null;
      }).forEach(function (arg) {
        sbase = "".concat(sbase).concat(arg.toString());
      });
      return sbase;
    }
  }, {
    key: "INT",
    value:
    // eslint-disable-next-line class-methods-use-this
    function INT(arg) {
      return parseInt(arg, 10);
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "CEIL",
    value: function CEIL(arg) {
      var farg = parseFloat(arg);
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(farg)) {
        return null;
      }
      return Math.ceil(farg);
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "FLOOR",
    value: function FLOOR(arg) {
      var farg = parseFloat(arg);
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(farg)) {
        return null;
      }
      return Math.floor(farg);
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "ROUND",
    value: function ROUND(arg) {
      var nDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';
      var farg = parseFloat(arg);
      var fnum = parseInt(nDigits, 10);

      // eslint-disable-next-line no-restricted-globals
      if (isNaN(farg) || isNaN(fnum)) {
        return null;
      }
      var digits = fnum > 20 ? 20 : fnum;
      if (digits > 0) {
        return parseFloat(farg.toFixed(digits));
      }
      var rounder = Math.pow(10, Math.abs(digits));
      return Math.round(farg / rounder) * rounder;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "BOOL",
    value: function BOOL(arg) {
      return !!arg;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "REAL",
    value: function REAL(arg) {
      return parseFloat(arg);
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "STR",
    value: function STR(arg) {
      if (arg === undefined) {
        return null;
      }
      if (arg === null) {
        return '';
      }
      return arg.toString();
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "LOWER",
    value: function LOWER(arg) {
      if (arg === undefined) {
        return null;
      }
      if (arg === null) {
        return '';
      }
      return arg.toString().toLowerCase();
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "UPPER",
    value: function UPPER(arg) {
      if (arg === undefined) {
        return null;
      }
      if (arg === null) {
        return '';
      }
      return arg.toString().toUpperCase();
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "CAPITALIZE",
    value: function CAPITALIZE(arg) {
      if (arg === undefined) {
        return null;
      }
      if (arg === null) {
        return '';
      }
      var sarg = arg.toString().toLowerCase();
      return "".concat(sarg.charAt(0).toUpperCase()).concat(sarg.slice(1));
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "TITLE",
    value: function TITLE(arg) {
      if (arg === undefined) {
        return null;
      }
      if (arg === null) {
        return '';
      }
      return arg.toString().toLowerCase().replace(/\b\w/g, function (m) {
        return m.toUpperCase();
      });
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "PRECISION",
    value: function PRECISION(arg, precision) {
      var parsedPrecision = parseInt(precision, 10);
      if (parsedPrecision <= 0) {
        throw new Error('Precision argument must be of type integer and greater than 0.');
      }
      return parseFloat(arg).toFixed(parsedPrecision);
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "SUBSTR",
    value: function SUBSTR(str, offset, length) {
      var parsedOffset = parseInt(offset, 10);
      var parsedLength = parseInt(length, 10);
      if (parsedOffset < 0) {
        throw new Error('Offset must be of type integer and greater than or equal to 0.');
      }
      if (parsedOffset > str.length) {
        throw new Error('Offset cannot be larger than the length of the given string.');
      }
      if (parsedLength <= 0) {
        throw new Error('Length must be of type integer and greater than 0.');
      }
      if (parsedOffset + parsedLength > str.length) {
        throw new Error('The value of length exceeds the length of the string.');
      }
      return str.substr(parsedOffset, parsedLength);
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "TRIM",
    value: function TRIM(arg) {
      return arg.trim();
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "MOD",
    value: function MOD(a, b) {
      return parseFloat(a) % parseFloat(b);
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "POW",
    value: function POW(a, b) {
      return Math.pow(parseFloat(a), parseFloat(b));
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "LCM",
    value: function LCM() {
      for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
        args[_key11] = arguments[_key11];
      }
      [].slice.call(args);
      if (args.length < 2) {
        throw new Error('LCM requires at least 2 arguments.');
      }
      var iargs = flatten(args).filter(function (arg) {
        return arg !== null;
      }).map(function (arg) {
        return parseInt(arg, 10);
      });
      var _iargs = _slicedToArray(iargs, 1),
        ret = _iargs[0];
      iargs.slice(1).forEach(function (x) {
        ret = ret * x / gcd(ret, x);
      });
      return ret;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "GCD",
    value: function GCD() {
      for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
        args[_key12] = arguments[_key12];
      }
      [].slice.call(args);
      if (args.length < 2) {
        throw new Error('GCD requires at least 2 arguments.');
      }
      var iargs = flatten(args).filter(function (arg) {
        return arg !== null;
      }).map(function (arg) {
        return parseInt(arg, 10);
      });
      var _iargs2 = _slicedToArray(iargs, 1),
        ret = _iargs2[0];
      iargs.slice(1).forEach(function (x) {
        ret = gcd(ret, x);
      });
      return ret;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "STRSPLIT",
    value: function STRSPLIT(str) {
      var _by = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';
      return str.split(_by);
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "STRJOIN",
    value: function STRJOIN(_by, list) {
      return list.join(_by);
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "PART",
    value: function PART(list, index) {
      return list[index];
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "ABS",
    value: function ABS(arg) {
      var farg = parseFloat(arg);
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(farg)) {
        return null;
      }
      return Math.abs(farg);
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "SGN",
    value: function SGN(arg) {
      var farg = parseFloat(arg);

      // eslint-disable-next-line no-restricted-globals
      if (farg === 0 || isNaN(farg)) {
        return arg;
      }
      return farg > 0 ? 1 : -1;
    }

    // eslint-disable-next-line class-methods-use-this
  }, {
    key: "ERROR",
    value: function ERROR() {
      throw new Error();
    }
  }, {
    key: "dateTimeParam",
    value:
    // eslint-disable-next-line class-methods-use-this
    function dateTimeParam(arg) {
      if (arg instanceof Context) {
        return arg._value;
      }
      return arg;
    }
  }]);
  return Context;
}(); // eslint-disable-next-line import/prefer-default-export
exports.Context = Context;